import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AuthGuardProps {
  children: React.ReactNode;
  /** @deprecated 未登录时将跳转根路径登录页，并通过 state 带回跳地址 */
  redirectTo?: string;
}

/** 未登录时跳转到系统登录页（/），登录成功后回到原访问路径 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { token } = useAuth();
  const location = useLocation();

  if (token) {
    return <>{children}</>;
  }

  return <Navigate to="/" replace state={{ from: location }} />;
};

export default AuthGuard;
